module.exports = __webpack_public_path__ + "img/ico-grade-platinum.c18eb721.svg";